//@mutations
export const mutations = {
  updateResource(state: any, resource: any) {
    state.resource = resource;
  },
  updateResourceId(state: any, resource_id: any) {
    state.resource_id = resource_id;
  },
}
